/**
 * Handles display of build and price CTA banner on SRP
 *
 * If a make is selected, a banner image of the make and
 * the make name (e.g. Ford) will be displayed
 *
 * If a model is selected, a banner image of the model and
 * the make + model name (e.g. Ford EcoSport) will be displayed
 *
 * If no model or make is provided, default values (if applicable) will be used
 * otherwise the elements will be hidden.
 *
 * @returns {boolean|void}
 */
function updateBuildAndPriceBanner(banner) {
  if (!banner) return false;

  let selectedDivision = document.querySelector('#make option:checked');
  let selectedModel = document.querySelector('#model option:checked');

  if (!selectedDivision || !selectedModel) {
    return false;
  }

  let division =
    selectedDivision && selectedDivision.dataset.slug ? selectedDivision.dataset.slug : '';

  let model = selectedModel && selectedModel.dataset.slug ? selectedModel.dataset.slug : '';

  let bannerImageWrapper = banner.querySelector('.bnp-banner__image-wrapper');
  let bannerImage = bannerImageWrapper.querySelector('.bnp-banner__image');

  let bannerDescription = banner.querySelector('.bnp-banner__description');
  let bannerDescriptionBrand = bannerDescription.querySelector('.bnp-banner__description-brand');

  let bannerButton = banner.querySelector('.bnp-banner__button');
  let bannerButtonBrand = bannerButton.querySelector('.bnp-banner__button-brand');

  // if no division or model is selected, check for defaults and reset, else hide elements.
  if (!division && !model) {
    if (bannerImage.dataset.image) {
      bannerImage.src = bannerImage.dataset.image;
    } else {
      bannerImageWrapper.classList.add('d-none');
    }

    if (bannerDescriptionBrand.dataset.brand) {
      bannerDescriptionBrand.textContent = bannerDescriptionBrand.dataset.brand;
    } else {
      bannerDescription.classList.add('d-none');
    }

    if (bannerButtonBrand.dataset.brand) {
      bannerButtonBrand.textContent = bannerButtonBrand.dataset.brand;
    } else {
      bannerButton.classList.add('d-none');
    }

    return false;
  }

  let query = new URLSearchParams({
    dsp_division_name: division,
    dsp_limit: 1,
    dsp_model_name: model,
    dsp_fields: 'division_name,default_image,model_id,model_name',
  });

  fetch('/showroom/search?' + query)
    .then((res) => res.json())
    .then((data) => {
      if (Array.isArray(data) && data.length > 0) {
        let vehicle = data[0];
        let link = bannerButton.dataset.link ? bannerButton.dataset.link : '';
        let image = bannerImage.dataset.image ? bannerImage.dataset.image : '';
        let bannerDescriptionText = bannerDescriptionBrand.dataset.brand
          ? bannerDescriptionBrand.dataset.brand
          : '';
        let bannerButtonText = bannerButtonBrand.dataset.brand
          ? bannerButtonBrand.dataset.brand
          : '';

        if (vehicle.division_name) {
          bannerDescriptionText = vehicle.division_name;
          bannerButtonText = vehicle.division_name;
        }

        if (model && vehicle.model_id && vehicle.model_name) {
          link += '/trims/' + vehicle.model_id;
          bannerDescriptionText += ' ' + vehicle.model_name;
        }

        if (vehicle.default_image.md.href) {
          image = vehicle.default_image.md.href;
        }

        bannerImage.src = image;
        bannerDescriptionBrand.textContent = bannerDescriptionText;

        bannerButtonBrand.textContent = bannerButtonText;
        bannerButton.href = link;

        bannerImageWrapper.classList.remove('d-none');
        bannerDescription.classList.remove('d-none');
        bannerButton.classList.remove('d-none');
      }
    })
    .catch((error) => {
      bannerImageWrapper.classList.add('d-none');
      bannerDescription.classList.add('d-none');
      bannerButton.classList.add('d-none');

      console.warn(error);
    });
}

export { updateBuildAndPriceBanner };
